const BrowserDetect = (function () {
  const systemVersionData = [
          {
            reg: /Win16/,
            label: '3.11'
          }, {
            reg: /(Windows 95)|(Win95)|(Windows_95)/,
            label: '95'
          }, {
            reg: /(Windows 98)|(Win98)/,
            label: '98'
          }, {
            reg: /(Windows NT 5.0)|(Windows 2000)/,
            label: '2000'
          }, {
            reg: /(Windows NT 5.1)|(Windows XP)/,
            label: 'XP'
          }, {
            reg: /(Windows NT 5.2)/,
            label: 'Server 2003'
          }, {
            reg: /(Windows NT 6.0)/,
            label: 'Vista'
          }, {
            reg: /(Windows NT 7.0)|(Windows NT 6.1)/,
            label: '7'
          }, {
            reg: /(Windows NT 4.0)|(WinNT4.0)|(WinNT)|(Windows NT)/,
            label: 'NT 4.0'
          }, {
            reg: /Windows ME/,
            label: 'Windows ME'
          }
        ],
        dataBrowser = [
          {
            string: navigator.userAgent,
            subString: 'Chrome',
            identity: 'Chrome'
          }, {
            string: navigator.userAgent,
            subString: 'OmniWeb',
            versionSearch: 'OmniWeb/',
            identity: 'OmniWeb'
          }, {
            string: navigator.vendor,
            subString: 'Apple',
            identity: 'Safari',
            versionSearch: 'Version'
          }, {
            prop: window.opera,
            identity: 'Opera',
            versionSearch: 'Version'
          }, {
            string: navigator.vendor,
            subString: 'iCab',
            identity: 'iCab'
          }, {
            string: navigator.vendor,
            subString: 'KDE',
            identity: 'Konqueror'
          }, {
            string: navigator.userAgent,
            subString: 'Firefox',
            identity: 'Firefox'
          }, {
            string: navigator.vendor,
            subString: 'Camino',
            identity: 'Camino'
          }, { // for newer Netscapes (6+)
            string: navigator.userAgent,
            subString: 'Netscape',
            identity: 'Netscape'
          }, {
            string: navigator.userAgent,
            subString: 'MSIE',
            identity: 'Explorer',
            versionSearch: 'MSIE'
          }, {
            string: navigator.userAgent,
            subString: 'Gecko',
            identity: 'Mozilla',
            versionSearch: 'rv'
          }, { // for older Netscapes (4-)
            string: navigator.userAgent,
            subString: 'Mozilla',
            identity: 'Netscape',
            versionSearch: 'Mozilla'
          }
        ],
        dataOS = [
          {
            string: navigator.platform,
            subString: 'Win',
            identity: 'Windows'
          }, {
            string: navigator.platform,
            subString: 'Mac',
            identity: 'Mac'
          }, {
            string: navigator.userAgent,
            subString: 'iPhone',
            identity: 'ios'
          }, {
            string: navigator.userAgent,
            subString: 'iPad',
            identity: 'ios'
          }, {
            string: navigator.userAgent,
            subString: 'iPod',
            identity: 'ios'
          }, {
            string: navigator.platform,
            subString: 'Linux',
            identity: 'Linux'
          }
        ];

  let versionSearchString;

  function searchString(data) {
    let value;
    for (let i = 0; i < data.length; i += 1) {
      const dataString = data[i].string,
            dataProp = data[i].prop;
      versionSearchString = data[i].versionSearch || data[i].identity;
      if (dataString) {
        if (dataString.indexOf(data[i].subString) !== -1) {
          value = data[i].identity;
          break;
        }
      } else if (dataProp) {
        value = data[i].identity;
        break;
      }
    }
    return value;
  }

  function searchVersion(dataString) {
    const index = dataString.indexOf(versionSearchString);
    let value = null;
    if (index !== -1) {
      value = parseFloat(dataString.substring(index + versionSearchString.length + 1));
    }
    return value;
  }

  function searchOsVersion(database) {
    let value = null;
    for (let i = 0; i < database.length; i += 1) {
      const item = database[i];
      if (navigator.userAgent.search(item.reg) !== -1) {
        value = item.label;
        break;
      }
    }
    return value;
  }

  function browser() {
    return searchString(dataBrowser) || '';
  }

  function browserVersion() {
    return searchVersion(navigator.userAgent) || searchVersion(navigator.appVersion) || 'n/a';
  }

  function os() {
    return searchString(dataOS) || '';
  }

  function osVersion() {
    let osversion;
    if (os().toLowerCase() === 'mac') {
      if (navigator.userAgent.search(/(OS X) ([\d_]+)/) !== -1) {
        osversion = RegExp.$2.split('_').join('.');
      } else {
        osversion = 'n/a';
      }
    } else {
      osversion = searchOsVersion(systemVersionData) || 'n/a';
    }
    return osversion;
  }

  return {
    browser,
    browserVersion,
    os,
    osVersion
  };
}());

// if(!$( '#callback_browser_version').val()) $('#callback_browser_version').val( BrowserDetect.browserVersion );
// if(!$( '#callback_os_version').val()) $('#callback_os_version').val( BrowserDetect.OSVersion );
// if(!$( '#callback_os' ).val()) $('select#callback_os_ option[value='' + BrowserDetect.OS.toLowerCase() + '']').attr('selected', 'selected');
// if(!$( '#callback_browser' ).val()) $('select#callback_browser_ option[value='' + BrowserDetect.browser.toLowerCase() + '']').attr('selected', 'selected');

export default BrowserDetect;



// WEBPACK FOOTER //
// ./browserDetect.js